<template>
    <div>
        <b-row class="mb-2">
            <b-col class="text-right">
                <b-button  v-if="Core.Session.AuthUser.can('event_management_post')" @click="add" class="btn btn-light">{{Core.Definition.getDefinition('Nouvel événement')}}</b-button>
            </b-col>
        </b-row>
        <router-view></router-view>
    </div>
</template>

<script>
    export default {
        name: 'EventContainer',
        components: {
        },
        mounted() {
        },
        data () {
            return {
                Core: window.Core
            }
        },
        methods: {
            add() {
                if (this.$route.fullPath === window.Core.Definition.getDefinition('/evenement/evenements/nouvel-evenement')) {
                    location.reload()
                } else {
                    this.$router.push(window.Core.Definition.getDefinition('/evenement/evenements/nouvel-evenement'))
                }
            }
        }
    }
</script>
